import moment from 'moment'
// startDate is an obligatory field whereas endDate can be null or undefined
export const startDateIsBeforeEndDate = (
  startDate?: string | Date,
  endDate?: string | Date | null
) => {
  if (endDate === undefined || endDate === null) {
    return true
  } else if (startDate === undefined) {
    return false
  } else {
    return moment(startDate).isBefore(moment(endDate))
  }
}

// startDate is an obligatory field whereas endDate can be null or undefined
// Allows same date (useful for single-day periods)
export const startDateIsBeforeOrSameEndDate = (
  startDate?: string | Date,
  endDate?: string | Date | null
) => {
  if (endDate === undefined || endDate === null) {
    return true
  } else if (startDate === undefined) {
    return false
  } else {
    return moment(startDate).isSameOrBefore(moment(endDate))
  }
}
